import { BingAdsEventTypes } from '../../entities';
import { BingAdsService } from '../../interfaces';

export class BingAdsServiceDecorator implements BingAdsService {
  constructor(protected readonly bingAdsService: BingAdsService) {}

  track(eventName: BingAdsEventTypes, data: Record<string, unknown>) {
    this.bingAdsService.track(eventName, data);
  }

  isUetqRequired(): boolean {
    return this.bingAdsService.isUetqRequired();
  }

  isUetqAvailable(): boolean {
    return this.bingAdsService.isUetqAvailable();
  }
}
